import React from 'react'

import { get, identity, isArray, isString, keyBy, reduce } from 'lodash'

import InternalContext from './context'

const withContext = (config) => {
  let workingConfig = config
  if (isString(workingConfig)) {
    workingConfig = [workingConfig]
  }
  if (isArray(workingConfig)) {
    workingConfig = keyBy(workingConfig, identity)
  }
  const mapValueViaConfig = (context) =>
    reduce(
      workingConfig,
      (result, propField, contextField) => {
        result[propField] = get(context, contextField)
        return result
      },
      {},
    )
  return (WrappedComponent) => {
    const HoC = (props) => (
      <InternalContext.Consumer>
        {(value) => (
          <WrappedComponent
            {...mapValueViaConfig(value)}
            {...props}
          />
        )}
      </InternalContext.Consumer>
    )
    HoC.displayName = `RealtimeMessagingContext(${WrappedComponent.displayName || WrappedComponent.name})`
    return HoC
  }
}

export default withContext
